import React, { useState } from 'react'
import Button from 'js/components/Button/Button'
import { FormattedMessage, useIntl } from 'react-intl'

function subscribe(email, locale = 'se') {
  const formData = new URLSearchParams()
  formData.set('EMAIL', email)
  formData.set('OPT_IN', '1')

  const ukUrl =
    'https://476274d0.sibforms.com/serve/MUIEAGicYrIb4p6Hqqj9ZBHh0lEFfHwtTZXpE1jygTz5PamqJVxe2gy5iQyrceunq2Fyxzyls_Ppxjl1GHaGjSorKjen1q_CQZk6UuFVTS1iUtPYwHpGBVreBiK_rEBUemI8qog0ajIlsYke7mXHTo_eIWoiCVj60oGCd7S6f_2ONVpKBVAzx18JMx4sRmbA_X2JMOazD_fYaPrs?isAjax=1'
  const seUrl =
    'https://476274d0.sibforms.com/serve/MUIEABYWqAZiPt3LAV0MVWJACGtyryGG_Z6W8E0SOSzHRpkMNyRqx2kJA9QgzE6hpWaG3sURk0K8-vDshzgmy9VeMZJbaFpHpal0pAvqbGOD_arnasVEvPntTqGmaGvtZQyucCoWHDaLef38TXYThhabnsDqbCIsiCpz3Dc64XnsU515pvVH1HZVFCLLDfHv2M0rjbhykzXOBQDA?isAjax=1'

  const url = locale === 'en' ? ukUrl : seUrl

  return fetch(url, {
    method: 'POST',
    headers: {
      cookie: '__cfduid=d79534bff86c4d1361a30f07f5f2e3ffe1607702425',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'api-key':
        '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',
    },
    mode: 'no-cors',
    body: formData,
  }).catch((err) => {
    console.error(err)
  })
}

function verifyEmail(email) {
  return fetch(`https://cool-thunder-ba27.lifesum.workers.dev/?email=${email}`)
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (!data.email) return Promise.reject()
      return data.email
    })
}

type Props = {
  onSubscribed: (email: string) => void
  alreadyRegisteredButton?: React.ReactNode
  verify?: boolean
  isSubscribed?: React.ReactNode
}

function Subscribe({
  onSubscribed,
  alreadyRegisteredButton,
  verify,
  isSubscribed,
}: Props) {
  const [email, setEmail] = useState('')
  const [error, setError] = useState(false)
  const [existError, setExistError] = useState(false)
  const [hasSubscribed, setHasSubscribed] = useState(false)
  const emailRegex =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
  const { locale } = useIntl()

  const isValid = emailRegex.test(email)

  const handleSubmit = verify ? verifyEmail : subscribe

  if (verify && hasSubscribed) {
    return (
      <div>
        <FormattedMessage id="webinar_you_are_registred" />
      </div>
    )
  }
  if (hasSubscribed || isSubscribed) {
    return (
      <div className="flex flex-col">
        <div>
          <FormattedMessage id="webinar_registrated_info" />
        </div>

        <div className="mt-24 text-14">
          <FormattedMessage id="webinar_junk_mail" />
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col">
      {verify && (
        <h2 className="mb-16 text-20 font-demibold">
          <FormattedMessage id="webinar_enter_mail" />
        </h2>
      )}
      <div className="mb-16">
        <label className="mb-6">
          Email
          <input
            type="email"
            name="email"
            placeholder={locale === 'en' ? 'Enter email' : 'Fyll i din email'}
            className="mt-6 rounded-full border border-Border bg-white px-24 py-8"
            value={email}
            onChange={(e) => {
              setError(false)
              setEmail(e.target.value)
            }}
          />
        </label>
        {error && (
          <div className="text-red">
            <FormattedMessage id="webinar_incorrect_email" />
          </div>
        )}
        {existError && (
          <div className="text-red">
            <FormattedMessage id="webinar_nonexistant_email" />
          </div>
        )}
      </div>
      <div>
        <Button
          color="green"
          className="mb-12"
          onClick={() => {
            if (!isValid) return setError(true)
            handleSubmit(email, locale)
              .then(() => {
                setHasSubscribed(true)
                onSubscribed(email)
              })
              .catch(() => {
                setExistError(true)
              })
          }}
        >
          {verify ? (
            <FormattedMessage id="webinar_login" />
          ) : (
            <FormattedMessage id="webinar_register" />
          )}
        </Button>
        <div>{alreadyRegisteredButton}</div>
      </div>
    </div>
  )
}

export default Subscribe
